import { StyledStrategyExercisesButton } from 'components/StrategyExercises/StrategyExercises.styled';
import { IStyledProps } from '../../theme';
import { Button } from '../Button/Button';
import { Heading } from '../Heading/Heading';
import { SvgIcon } from '../SvgIcon/SvgIcon';

import styled from 'styled-components';

export const StyledSummaryContainer = styled.div`
  color: ${(props: IStyledProps) => props.theme.colors.white};
  display: flex;
  align-content: start;
  flex-direction: column;
`;


export const StyledNavWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  text-align: right;
  justify-content: flex-end;
  padding-right: 20px;
`;

export const StyledSummaryHeaderButton = styled(Button)`
  background: ${(props: IStyledProps) => props.theme.colors.greys.d};
  color: ${(props: IStyledProps) => props.theme.colors.white};
  margin-top: 15.5px;
  margin-bottom: 2rem;
  width: 125px;
  padding: 8px;

  span {
    letter-spacing: 0em;
    font-size: 14px;
  }
`;

export const StyledSummaryHeader = styled.div`
  width: 100%;
  padding: 20px 20px;
`;

export const StyledSummaryTitle = styled(Heading).attrs({ primary: true, level: 'h1' })`
  display: block;
  text-align: left;
  font-size: 42px;
  line-height: 48px;
  text-transform: none;
`;

export const StyledSummarySubTitle = styled(Heading).attrs({ primary: true, level: 'h4' })`
  letter-spacing: 2px;
  margin-top: 24px;
  text-align: left;
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
`;

export const StyledSummaryHeaderIcon = styled(SvgIcon)`
  height: 90px;
  width: 90px;
  margin-bottom: 24px;
  opacity: 0.3;

`;

export const StyledPlanSummary = styled.div`
  svg {
    width: 80px;
    height: 80px;
  }
  > div {
    align-items: center;
    text-align: center;
  }
`;

export const StyledPlanRemember = styled.div`
  text-align: left;
  `;

export const StyledSummaryContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: left;
  text-align: left;
  padding: 20px 20px;
  
  svg {
    margin-bottom: 20px;
  }
`;

export const StyledSummaryContentHeadingText = styled(Heading).attrs({ primary: true, level: 'h5' })`
  text-align: left;
  font-size: 40px;
`;

export const StyledSummaryContentText = styled.div`
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-bottom: 18px;
  width: 90%;

  @media screen and (min-width: 375px) {
    width: 80%;
  }

  ul {
    padding-left: 28px;

    li {
      padding-left: 6px;
      margin-bottom: 10px;
    }
  }
`;

export const StyledSummaryContentTextList = styled(StyledSummaryContentText)`
  &&& {
    width: 90%;
    margin-top: -1rem;
    margin-bottom: 0rem;
  }
`;

export const StyledSummaryContentImage = styled.img`
  margin: 0px auto;
  max-width: 100%;
  margin-bottom: 3rem;
`;

export const StyledIconContentContainer = styled.div`
  display: block;
  position: relative;
  white-space: nowrap;
  margin-bottom: 32px;
  margin-top: 3rem;
`;
export const StyledIconContent = styled.div`
  position: relative;
  height: 100%;
  vertical-align: top;
  width: calc(100% - 38px);

`;
export const StyledIcon = styled.img`
  display: inline-block;
  position: relative;
  width: 65px;
  vertical-align: top;
  margin-bottom: 10px;
`;

export const StyledIconTitle = styled(Heading).attrs({ primary: true, level: 'h4' })`  
  text-align: left;
`;

export const StyledIconQuote = styled(Heading).attrs({ level: 'h5' })`
  text-align: left;
  font-style: italic;
  white-space: normal;
  font-size: 20px;
  margin-top: 5px;

  @media screen and (min-width: 400px) {
    width: 80%;
  }
`;

export const StyledButton = styled(StyledStrategyExercisesButton)`
  background: #3E3E3E;
  margin-top: 16px;
  width: 100%;
`;
